import { AuditLiveMentionConfidence } from '@mi-front/core';
import { Chip } from '@mi-front/ui';

import { FormattedMessage } from 'react-intl';

import { liveMentionStatusMessages } from './live-mention-status.messages';

export const LiveMentionConfidence = ({ value }: { value: AuditLiveMentionConfidence }) => {
  return (
    <Chip
      size="sm"
      type={value === 'ACCEPTED' ? 'success' : value === 'REJECTED' ? 'danger' : 'light'}
    >
      <FormattedMessage {...liveMentionStatusMessages[value]} />
    </Chip>
  );
};
